
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Badminton  Tournament</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
	<div class="container">

		<div class="title-heading inner-heading text-center mb-5 shadow-text-sm">
			<h4> G H Raisoni Memorial Nagpur District <span >Badminton Tournament 2023 </span></h4>
		</div>
		<div class="row">
			<div class="col-lg-8">
				<p class="text-justify">The thrill of shuttlecock and racquet echoed across the courts during the G H
					Raisoni Memorial Nagpur District Badminton Tournament 2023 held at Dhanwate College, Congress Nagar,
					Nagpur, from August 11th to 13th, 2023. The competition was organised by the esteemed G H Raisoni
					Sports & Cultural Foundation in collaboration with the Nagpur District Badminton Association and
					proudly affiliated with the Maharashtra Badminton Association. Three days of strong competition and
					collaboration were slated at this tournament.</p>
				<p class="text-justify">The tournament provided a platform for young badminton enthusiasts, aged Under -
					9, Under - 11, and Under - 13, to showcase their talents. Supported by the Nagpur District Badminton
					Association affiliated to Maharashtra Badminton Association, fostering growth and sportsmanship to
					the participants. Certificates were awarded to all participants, with medals and cash prizes to the
					champions in each category.</p>
			</div>
			<div class="col-lg-4 text-center">
				<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/ghraisoni_badminton_tournament.webp"
					alt="ghraisoni_badminton_tournament" title="ghraisoni_badminton_tournament" class="img-fluid" />
			</div>
		</div>
	</div>

</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="col-md-8">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>
						<div class="col-md-4 text-end">
							<a href="/photogallery#badminton" class="cmn-button"><span>
									View More</span>
							</a>
						</div>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</section>
